const getDefaultApiBaseUrl = () => {
  if (typeof window === "undefined") return "http://localhost:8000/api/v1";

  const { protocol, hostname, host } = window.location;
  const isLocalHost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    /^10\./.test(hostname) ||
    /^192\.168\./.test(hostname);

  return isLocalHost ? "http://localhost:8000/api/v1" : `${protocol}//${host}/api/v1`;
};

const DEFAULT_API_BASE_URL = getDefaultApiBaseUrl();

export const API_BASE_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  DEFAULT_API_BASE_URL
).replace(/\/$/, "");

export const API_ORIGIN = API_BASE_URL.replace(/\/api\/v\d+\/?$/i, "").replace(/\/$/, "");

export const getMediaUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_ORIGIN}/asserts/services/${String(path).replace(/^\/+/, "")}`;
};

export const fetchServices = async () => {
  const response = await fetch(`${API_BASE_URL}/services?t=${Date.now()}`, {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Unable to load services (${response.status})`);
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
};
